module.exports = __webpack_public_path__ + "ec58b2df8d77a97549d99ea461400ca6.pdf";